import React from 'react'
import { node, string, func } from 'prop-types'
import DocumentTitle from 'react-document-title'

import { withI18n } from '@active/react-utils/i18n'
import Footer from '../Footer'
import Header from '../Header'
import DefaultComponentLayout, { LayoutContent } from '../Layout'

function ContentWithBanners({
  children,
  title,
  i18n,
  className,
}) {
  return (
    <div className="passport-page-block">
      <DefaultComponentLayout nameSpace="passport-page-block__content">
        <DocumentTitle title={i18n(title)} />
        <LayoutContent main>
          <div className={`passport-card ${className}`}>
            <Header />
            {children}
          </div>
        </LayoutContent>
      </DefaultComponentLayout>
      <Footer />
    </div>
  )
}

ContentWithBanners.propTypes = {
  children: node.isRequired,
  title: string,
  i18n: func.isRequired,
  className: string,
}

ContentWithBanners.defaultProps = {
  title: 'title.signin',
  className: '',
}

export default withI18n(ContentWithBanners)
